import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { addToCart, updateCartQuantity } from '../redux/cartSlice';
import ImageWithThumbnails from './ImageWithThumbnails';
import { ToastContainer, toast } from 'react-toastify';

const ProductDescription = () => {
  const dispatch = useDispatch();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { productId } = useParams();
  const [productDetail, setProductDetail] = useState([]);
  const [price,setPrice] = useState(0);
  const [defaultPrice,setDefaultPrice] = useState(0);
  const [selectColor, setSelectColor] = useState('');
  const [selectSize, setSelectSize] = useState('');
  
  const cartItem = useSelector((state) =>
    state.cart.cart.find((item) => item.code === productId &&
        item.color === selectColor &&
        item.size === selectSize)
  );

  const initialQuantity = cartItem ? cartItem.quantity : 1;

  const [quantity, setQuantity] = useState(initialQuantity);

  const handleQuantityChange = (operation) => {
    setQuantity((prevQuantity) => {
      if (operation === 'increase' && prevQuantity < 10) {
        return prevQuantity + 1;
      } else if (operation === 'decrease' && prevQuantity > 1) {
        return prevQuantity - 1;
      }
      return prevQuantity;
    });
  };

  const toastingMessage = (type, message) => {
    const toastProps = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      };
      switch (type) {
        case 'warn':
          toast.warn(message, toastProps);
          break;
        case 'success':
          toast.success(message, toastProps);
          break;
        default:
          toast.info('Default message', toastProps);
      }
  }

  const handleAddToCart = () => {
    if(selectColor == ""){
        toastingMessage("warn","Kindly select color for add to cart!!");
        return;
    }
    if(selectSize == ""){
        toastingMessage("warn","Kindly select size for add to cart!!");
        return;
    }
    const item = {
      id: productDetail.id,
      name: productDetail.name,
      price: !price ? defaultPrice : price,
      quantity: quantity,
      code: productDetail.product_code,
      size: selectSize,
      color: selectColor,
      image: productDetail.thumbnail
    };

    if (cartItem) {
      dispatch(updateCartQuantity(item));
      toastingMessage("success","Product Updated to cart");
    } else {
      dispatch(addToCart(item));
      toastingMessage("success","Product Added to cart");
    }
  };

    const fetchData = async () =>{
        try {
            let url = `${apiBaseUrl}getProductById?code=${productId}`;
            const response = await fetch(url);
            const data = await response.json();
            setProductDetail(data.data);
            setDefaultPrice(data.data.price);
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchPrice = async () => {
        try {
            if(selectColor != "" || selectSize != ""){
                let url = `${apiBaseUrl}getprice?product=${productId}&color=${selectColor}&size=${selectSize}`;
                const response = await fetch(url);
                const data = await response.json();
                if(data.length > 0){
                    setPrice(data[0]['size_price']);
                }
                else{
                    setPrice(productDetail.price);
                }
            }
            else{
                setPrice(productDetail.price);
            }
            
            // return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        fetchData();
        setSelectColor(productDetail.colors ? productDetail.colors[0] : '');
        setSelectSize(productDetail.sizes ? productDetail.sizes[0] : '');
    },[productId])

    useEffect(() => {
        fetchPrice();
    },[selectColor, selectSize])

  return (

    <div className="main-container">
        <div className="left-column">
            <ImageWithThumbnails thumbImage={productDetail.thumbnail} thumbnails={productDetail.images} />
        </div>
        
        <div className="right-column">
        
            <div className="product-description">
            <span>{productDetail.categoryname}</span>
            <h1>{productDetail.name}</h1>
            <p>{productDetail.description}</p>
            </div>
        
            <div className="product-configuration">
        
            {
                productDetail.colors && (<>
            <div className="product-color">
                <span key={productId}>Color</span>
        
                <div className="color-choose">
                {
                    productDetail.colors.map((color,i) => (<>
                        <div key={i}>
                            <input data-image={color} type="radio" onClick={() => setSelectColor(color)} id={color} name="color" value={color} />
                            <label htmlFor={color}><span style={{backgroundColor: `${color}`}}></span></label>
                        </div>
                        </>))
                }
                </div>
        
            </div>
            </>)
            }
        
        {
            productDetail.sizes && (
                <>
                
            <div className="cable-config">
                <span>Sizes</span>
        
                <div className="cable-choose">
                    {
                        productDetail.sizes.map((size,i) => (
                            <button key={i} onClick={() => setSelectSize(size)} className={`mr-1 ${size == selectSize ? 'active' : ''}`}>{size}</button>
                        ))
                    }
                </div>
            </div>
            </>
            )
        }
            </div>
        
            <div className="product-price">
            <span>₹ {!price ? defaultPrice : price}</span>
            {/* <a href="#" className="cart-btn">Add to cart</a> */}
            </div>
            <div className='d-flex justify-content-center mt-3'>
                <div className="quantity-controls w-50">
                    <div class="input-group">
                        <button id="decrement" onClick={() => handleQuantityChange('decrease')}>-</button>
                        <input type="number" value={quantity} id="input"
                        onChange={(e) => setQuantity(Number(e.target.value))}
                        min="1" readonly maxLength="10"/>
                        <button id="increment" onClick={() => handleQuantityChange('increase')}>+</button>
                    </div>
                </div>
                
                {/* Add to Cart button */}
                <div className='w-50'>
                <button
                    className="button-53"
                    onClick={handleAddToCart}
                    role="button"
                >
                    {cartItem ? 'Update Cart' : 'Add to Cart'}
                </button>
                <ToastContainer />
                </div>
            </div>
            
        </div>
        </div>

  );
};

export default ProductDescription;
